import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const number = "16476099266";
  const message = encodeURIComponent("Hi, I'd like a free cleaning estimate.");
  const href = `https://wa.me/${number}?text=${message}`;
  return (
    <a
      data-testid="whatsapp-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_-10px_rgba(37,211,102,0.7)] transition-transform hover:scale-110"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <MessageCircle size={26} strokeWidth={2.2} className="relative z-10" />
    </a>
  );
}
